import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';
// import { getVistaPresupuestosInternosList, getVistaPresupuestosInternosAbiertosList } from '../../helpers/user_mv';

const state = {
    facturasProforma: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    cliente: null,
    contacto: null,
    numeroPI: 0,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.facturaProforma = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.cliente = null;
        state.contacto = null;
        state.numeroPI = 0;
        state.sortByDescending = true;
    },

    'INICIALIZAR_FACTURAS' (state) {
        state.facturasProforma = [];
    },
    'SET_FACTURAS' (state, facturasProforma) {
        // state.facturasProforma = facturasProforma;
        state.facturasProforma = facturasProforma.map(facturaProforma => (
            { ...facturaProforma, 
                anulado: moment(facturaProforma.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' ? false : true
                // _rowVariant: moment(facturaProforma.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' ? 'danger' : ''  
            }
        ));
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getFacturasProforma ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FACTURAS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&sortByDescending='+ state.sortByDescending;
            
            if (state.numero != 0) {
                queryString += '&numero=' + state.numero;
            }
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            if (state.contacto) {
                if (state.contacto.id != 0) {
                    queryString += '&contactoId=' + state.contacto.id;
                }
            }
            if (state.numeroPI != 0) {
                // queryString += '&presupuestoInternoId=' + state.numeroPI;
                queryString += '&presupuestoNumero=' + state.numeroPI;
            }
                
            apiAxios.get('facturasproforma' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_FACTURAS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    anular ( {}, facturaProformaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('facturasproforma/' + facturaProformaId + '/delete')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}